<template>
  <div class="loading" :class="{ 'is-loading': loading }" v-show="loading">
    <svg class="spinner" width="80px" height="80px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle class="path" fill="none" stroke="#DC1C2E" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
    </svg>

    <span class="h2 t-inverse t-bold">Give us a second...</span>
    <p class="t-inverse">Content is loading</p>
  </div>
</template>

<style scoped lang="scss">
  $offset: 187;
  $duration: 1.4s;
  
  .loading {
    &.is-loading {
      position: fixed;
      left: 0;
      top: 0;
      z-index: 999999;

      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100vw;
      height: 100vh;
      background-color: rgb(var(--blue-0));

      .spinner {
        animation: rotator $duration linear infinite;
      }

      .path {
        animation: dash $duration ease-in-out infinite;
      }
    }

    .h2 {
      margin-bottom: 5px;
      font-size: 2.8rem;
    }
    
    .spinner {
      margin-bottom: 30px;
    }

    .path {
      stroke-dasharray: $offset;
      stroke-dashoffset: 0;
      transform-origin: center;
    }

    @keyframes rotator {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(270deg); }
    }

    @keyframes dash {
      0% { 
        stroke-dashoffset: $offset; 
      }

      50% {
        stroke-dashoffset: $offset/4;
        transform:rotate(135deg);
      }

      100% {
        stroke-dashoffset: $offset;
        transform:rotate(450deg);
      }
    }
  }
</style>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'Loading',

    computed: {
      ...mapState([
        'loading'
      ])
    }
  };
</script>